import { format } from 'date-fns';

export const get12HourTime = (time: string) => {
	const [hours, minutes] = time.split(':');
	const date = new Date(2023, 1, 1, Number(hours), Number(minutes));

	return format(date, 'h:mmaaa');
};
